import { Link } from "react-router-dom";
import { Reveal } from "./motion";

export const SectionLabel = ({ children, index }) => (
  <div className="flex items-center gap-3 mb-5">
    {index && <span className="font-heading text-accent text-sm font-black">{index}</span>}
    <span className="text-xs tracking-[0.25em] uppercase font-bold text-accent">{children}</span>
    <span className="h-px w-12 bg-accent/40" />
  </div>
);

export const PillButton = ({ to, children, variant = "primary", onClick, type, testid, className = "" }) => {
  const base = "inline-flex items-center justify-center rounded-full px-7 py-3.5 text-sm font-semibold transition-all duration-300";
  const styles =
    variant === "primary"
      ? "bg-accent text-white hover:scale-105 hover:shadow-[0_10px_40px_rgba(230,57,70,0.4)]"
      : "border border-foreground/20 hover:bg-foreground/5 hover:border-foreground/40";
  if (to) return <Link to={to} data-testid={testid} className={`${base} ${styles} ${className}`}>{children}</Link>;
  return <button type={type} onClick={onClick} data-testid={testid} className={`${base} ${styles} ${className}`}>{children}</button>;
};

export const PageHero = ({ label, title, subtitle }) => (
  <section className="relative pt-40 pb-16 md:pt-48 md:pb-20 overflow-hidden">
    <div className="absolute top-20 -right-20 w-96 h-96 accent-glow rounded-full" />
    <div className="max-w-7xl mx-auto px-6 md:px-10 relative">
      <Reveal>
        <SectionLabel>{label}</SectionLabel>
        <h1 className="text-5xl md:text-6xl lg:text-7xl font-black uppercase tracking-tighter leading-[0.9] max-w-4xl">
          {title}
        </h1>
        {subtitle && <p className="mt-6 text-lg text-muted-foreground max-w-2xl leading-relaxed">{subtitle}</p>}
      </Reveal>
    </div>
  </section>
);
